import e from "./index236.mjs";
const a = e();
export {
  a as default
};
